import { useState } from "react";
import { toast } from "sonner";
import { Eye, X } from "lucide-react";
import { api, adminHeaders } from "../lib/api";

/**
 * Fixed banner shown when viewing the site in draft-preview mode (?preview=1).
 * Lets the admin publish the previewed draft live or exit the preview.
 */
export default function PreviewBanner() {
  const [busy, setBusy] = useState(false);

  const exitPreview = () => {
    const url = new URL(window.location.href);
    url.searchParams.delete("preview");
    window.location.href = url.toString();
  };

  const publish = async () => {
    setBusy(true);
    try {
      await api.post("/admin/content/publish", {}, { headers: adminHeaders() });
      toast.success("Draft published live");
      setTimeout(exitPreview, 600);
    } catch (err) {
      toast.error(err?.response?.status === 400 ? "No draft to publish" : "Publish failed");
      setBusy(false);
    }
  };

  return (
    <div
      data-testid="preview-banner"
      className="fixed top-0 inset-x-0 z-[9999] bg-crimson text-onaccent flex items-center justify-center gap-6 px-6 py-2.5 shadow-lg"
    >
      <span className="inline-flex items-center gap-2 font-mono text-[11px] uppercase tracking-[0.2em]">
        <Eye className="w-4 h-4" /> Preview — viewing unpublished draft
      </span>
      <button
        onClick={publish}
        disabled={busy}
        data-testid="preview-publish"
        className="font-mono text-[11px] uppercase tracking-[0.2em] px-4 py-1.5 bg-vellum text-ink hover:bg-ink hover:text-onaccent transition-colors disabled:opacity-50"
      >
        {busy ? "Publishing…" : "Publish live"}
      </button>
      <button
        onClick={exitPreview}
        data-testid="preview-exit"
        className="inline-flex items-center gap-1 font-mono text-[11px] uppercase tracking-[0.2em] hover:opacity-70 transition-opacity"
      >
        <X className="w-3.5 h-3.5" /> Exit
      </button>
    </div>
  );
}
